var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBahrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M38.345,423.724h102.898l70.621-20.966l-70.621-20.966l70.621-20.966l-70.621-20.966l70.621-20.966 l-70.621-20.966l70.621-20.966L141.242,256l70.621-20.966l-70.621-20.966l70.621-20.966l-70.621-20.966l70.621-20.966 l-70.621-20.966l70.621-20.966l-70.621-20.966H38.345C17.167,88.276,0,105.443,0,126.621V385.38 C0,406.557,17.167,423.724,38.345,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M141.241,130.207l70.621,20.966l-70.621,20.966l70.621,20.966l-70.621,20.966l70.621,20.966 L141.241,256l70.621,20.966l-70.621,20.966l70.621,20.966l-70.621,20.966l70.621,20.966l-70.621,20.966l70.621,20.966 l-70.621,20.966h332.414c21.177,0,38.345-17.167,38.345-38.345V126.621c0-21.177-17.167-38.345-38.345-38.345H141.242l70.621,20.966 L141.241,130.207z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahrain);
export default __webpack_public_path__ + "static/media/bahrain.59e93f881af379502fff0f4a0f84955a.svg";
export { ForwardRef as ReactComponent };